module.exports = __webpack_public_path__ + "32725d5d5abf7d7c27ae92b046dc390e.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/aa-2001-black.jpg
// module id = 821
// module chunks = 0